import { useState } from "react";

const FAQS = [
  {
    q: "打包下载和批量下载有什么区别？",
    a: "打包下载是把整批资源压缩成单个文件，一次性取用完整合集，适合整册收藏与归档；批量下载则是把多本资源依次加入队列逐个拉取，适合边下边整理。前者重“结果完整”，后者重“过程可控”，可按需选择或组合使用。",
  },
  {
    q: "离线下载一定要有离线空间吗？",
    a: "不一定。离线下载的核心是让下载过程不依赖本地网络波动，一般通过云端中转空间或下载器的离线加速功能实现。如果网速稳定、文件不大，也可以直接本地下载；需要长期留档或大文件时，离线方式更稳妥。",
  },
  {
    q: "为什么我的资源下载总是失败？",
    a: "绝大多数失败来自两方面：一是网络不稳定导致中断，二是本地存储空间不足。建议先清点空间，再用支持断点续传的下载器，把大文件转入离线空间再转存，基本能解决问题。",
  },
  {
    q: "批量下载会不会漏掉某些资源？",
    a: "勾选清单前建议先核对资源数量与系列完整性。稳妥做法是先在列表页统一勾选，再加入队列并检查队列数量是否与预期一致，这样能最大程度避免遗漏或重复。",
  },
  {
    q: "下载后文件很乱，该如何整理归档？",
    a: "可用压缩与整理工具做三件事：解压统一格式、批量重命名、按作者或系列建立目录。推荐采用“作者_系列_标题”的命名规范，需要时再打成压缩包，方便日后移动与检索。",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
            <i className="ri-questionnaire-line"></i>
            常见问题
          </span>
          <h2 className="font-display text-2xl md:text-4xl text-foreground-950 mt-3">
            下载前先看看这里
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            整理了一些大家最常问的问题，先对号入座，能帮你省不少排查时间。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {FAQS.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border bg-background-50 transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3 text-sm md:text-base font-semibold text-foreground-950">
                    <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 text-xs">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <span
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-transform ${
                      open ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 md:px-6 pb-5 pl-[64px] text-sm text-foreground-700 leading-relaxed">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}